import React, { Component } from "react";
import { Line } from "react-chartjs-2";
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col, FormGroup } from "reactstrap";
import Select from 'react-select'
import Loader from '../Loader/Loader'

const options = {
    plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
    },
    scales: {
        y: {
            ticks: {
                padding: 0,
                color: "#9f9f9f",
                beginAtZero: false,
                maxTicksLimit: 10,
            },
            grid: {
                drawBorder: true,
                display: true,
            },
        },
        x: {
            barPercentage: 1.6,
            grid: {
                drawBorder: true,
                display: false,
            },
            ticks: {
                padding: 0,
                color: "#9f9f9f",
                maxTicksLimit: 50
            },
        },
    },
}
class ChartRevenue extends Component {
    constructor(props) {
        super(props);
        this.year = ""
        this.state = {
            data: [],
            stats: [],
            isLoading: false,
            yearsList: [],
        };
    }
    loadStats7() {
        if (this.year !== "" && this.product !== "") {
            this.setState({ isLoading: true })
            return fetch('https://tdb.confotex.com/api/orders-stats-7/', {
                method: 'POST',
                headers: {
                    'authorization': window.sessionStorage.getItem('session_token'),
                    "x-my-custom-header": window.sessionStorage.getItem('iduser'),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    year: this.year.value,
                })
            })
                .then((reponse) => reponse.json())
                .then((data) => {
                    console.log(data);
                    if (data.reponse === "true") {

                        let data2 = []
                        data.stats.forEach(element => {
                            data2.push(element.somme2)
                        });
                        this.setState({ data: data2, stats: data.stats, isLoading: false })

                    } else if (data.reponse === "false") {
                        this.showNotification(data)
                    }
                    else {
                        this.setState({ isLoading: false })
                    }
                })
                .catch((error) => console.error(error));
        }
    }
    generateYears() {
        let max = new Date().getFullYear()
        let array = []
        for (let i = 2020; i <= max; i++) {
            let obj = {}
            obj.value = i
            obj.label = i
            array.push(obj)
        }
        this.setState({ yearsList: array })
    }
    componentDidMount() {
        this.generateYears()
    }
    render() {
        const formatter = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'DZD',
            minimumFractionDigits: 2
        });
        return (
            <>
                <Row>
                    <Col md="4">
                        <Card >
                            <CardBody className="justify-content-center d-flex">
                                <table className="table-sm table-hover table-responsive" style={{ height: 400, }}>
                                    <thead>
                                        <th>Mois</th>
                                        <th>C.A.</th>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.stats.map((value, index) => {

                                                //format amount
                                                let somme2 = formatter.format(value.somme2);
                                                return (
                                                    <tr key={index}>
                                                        <td>{value.lib_mois}</td>
                                                        <td>{somme2}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md="8">
                        <Card>
                            {/* DISPLAY LOADER */}
                            {this.state.isLoading && <div style={{ backgroundColor: "white", position: 'absolute', height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 99, borderRadius: 15 }}>
                                <Loader />
                            </div>}
                            <CardHeader>
                                <CardTitle tag="h5">Chiffre d'affaire mensuel</CardTitle>
                                <CardHeader>
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <label>
                                                    Année
                                                </label>
                                                <Select value={this.state.year} options={this.state.yearsList} onChange={(event) => { this.year = event; this.loadStats7() }} isSearchable={false} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardHeader>
                            </CardHeader>
                            <CardBody>
                                <Line
                                    data={(canvas) => {
                                        return {
                                            labels: ['Jan.', 'Fév', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Aout', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
                                            datasets: [
                                                {
                                                    borderColor: "#5499C7",
                                                    backgroundColor: '#b2d1e6',
                                                    pointRadius: 5,
                                                    pointHoverRadius: 10,
                                                    borderWidth: 1,
                                                    tension: 0.4,
                                                    fill: true,
                                                    data: this.state.data
                                                }
                                            ],
                                        };
                                    }}
                                    options={options}
                                    width={400}
                                    height={100}
                                />
                            </CardBody>
                            <CardFooter>
                                <hr />
                                <div className="stats" onClick={() => { this.loadStats7() }}>
                                    <i className="fas fa-history" /> Actualiser
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>

                </Row>

            </>

        );
    }
}

export default ChartRevenue;
